// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ticketgame:nth-child(2n) {
  background-color: #eaf6ff;
}

.prediction {
  display: flex;
  justify-content: center;
}

.divider {
  margin-block: 1rem;
  border: 1px dashed black;
}

.void-ticket__container {
  padding: 12px 24px;
  border: 2px solid #000000;
  border-radius: 8px;
}

@media print {
  .divider {
    margin-block: 4px;
    border: 1.5px dashed black;
  }
  .ticket-text {
    font-size: 12px;
  }
  .ticket-text__container {
    padding: unset;
    line-height: 4px;
  }
  .print-none {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/home/modals/styles/style.scss","webpack://./src/modules/home/modals/styles/style.css"],"names":[],"mappings":"AAAA;EAEI,yBAAyB;ACA7B;;ADIA;EAGC,aAAA;EAGC,uBAAkB;ACDpB;;AAEA;EDGA,kBAAA;EACE,wBAAkB;ACDpB;;AAEA;EACE,kBAAkB;EDGpB,yBAAY;EACV,kBAAS;ACDX;;AAEA;EDIE;IACE,iBAAe;IAChB,0BAAA;EAED;ECHA;IDKE,eAAa;ECHf;EDMA;IACE,cAAS;IACV,gBAAA;ECJD;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".ticketgame {\n  &:nth-child(2n) {\n    background-color: #eaf6ff;\n  }\n}\n\n.prediction {\n  display: flex;\n  justify-content: center;\n}\n\n.divider {\n  margin-block: 1rem;\n  border: 1px dashed black;\n}\n\n.void-ticket__container {\n  padding: 12px 24px;\n  border: 2px solid #000000;\n  border-radius: 8px;\n}\n\n@media print {\n  .divider {\n    margin-block: 4px;\n    border: 1.5px dashed black;\n  }\n\n  .ticket-text {\n    font-size: 12px;\n  }\n\n  .ticket-text__container {\n    padding: unset;\n    line-height: 4px;\n  }\n\n  .print-none {\n    display: none !important;\n  }\n}",".ticketgame:nth-child(2n) {\n  background-color: #eaf6ff;\n}\n\n.prediction {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.divider {\n  margin-block: 1rem;\n  border: 1px dashed black;\n}\n\n.void-ticket__container {\n  padding: 12px 24px;\n  border: 2px solid #000000;\n  border-radius: 8px;\n}\n\n@media print {\n  .divider {\n    margin-block: 4px;\n    border: 1.5px dashed black;\n  }\n  .ticket-text {\n    font-size: 12px;\n  }\n  .ticket-text__container {\n    padding: unset;\n    line-height: 4px;\n  }\n  .print-none {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
